import { render, staticRenderFns } from "./PercentagesByPriceRange.vue?vue&type=template&id=0cfcd006&"
import script from "./PercentagesByPriceRange.vue?vue&type=script&lang=js&"
export * from "./PercentagesByPriceRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports